module.exports = __webpack_public_path__ + "assets/img/report-title.eeddd01f.png";